import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import UiContext from "@store/ui-context";
import useAPIRequest from "@custom_hooks/simple/useAPIRequest";

const defaultTake = 10;
const JABATAN_ID_IT = 11;

export const useAPIGetJabatanSelector = (props) => {
  const uiContext = useContext(UiContext);
  const { requestGet, loading } = useAPIRequest();

  const { additionalFilter } = props;

  const user = useSelector((state) => state.auth.user);
  const isIT = user?.data_karyawan?.jabatan_id === JABATAN_ID_IT;

  const [filterValue, setFilterValue] = useState({
    kode: "",
    nama: "",
  });

  const [paging, setPaging] = useState({
    page: 1,
    take: defaultTake,
    total: 0,
    filter: "",
  });

  const [listData, setListData] = useState([]);
  const [listSelected, setListSelected] = useState([]);

  //  API call section

  const fetchListData = async ({ page, take, filter }) => {
    const newFilter = filter ?? getFilter(filterValue);

    return requestGet({
      fullUrl: `/api/masterdata/jabatan/data`,
      params: {
        page: page,
        take: take,
        filter: newFilter,
        order: "nama",
        order_method: "ASC",
      },
      onSuccess: ({ pagination, message, data }) => {
        setPaging({
          ...paging,
          total: pagination["total"],
          page: pagination["page"],
          take: pagination["take"],
          filter: newFilter,
        });
        const newData = data.map((el, index) => {
          return {
            ...el,
            no: (page - 1) * take + index + 1,
          };
        });
        setListData(newData);
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  // other function section

  const getFilter = (_filterValue) => {
    const filterArr = [];

    const newFilterValue = _filterValue ?? filterValue;

    if (newFilterValue.kode) {
      filterArr.push(`kode:contains:${newFilterValue.kode}`);
    }

    if (newFilterValue.nama) {
      filterArr.push(`nama:contains:${newFilterValue.nama}`);
    }

    // IT jabatan is only visible to IT users
    if (!isIT) {
      filterArr.push("kode:!=:IT");
    }

    if (additionalFilter) {
      filterArr.push(additionalFilter);
    }

    return filterArr.join(";");
  };

  // handle ui event section

  const handleOnClickRefresh = async () => {
    fetchListData({ page: 1, take: paging.take });
  };

  const handleOnPage = (e) => {
    const newPage = e.first / paging.take + 1;
    const newTake = e.rows;

    setPaging({ ...paging, take: newTake, page: newPage });
    fetchListData({ page: newPage, take: newTake, filter: paging.filter });
  };

  return {
    loading,
    listData,
    fetchListData,
    filterValue,
    setFilterValue,
    handleOnClickRefresh,
    handleOnPage,
    paging,
    listSelected,
    setListSelected,
  };
};
